export const environment = {
  production: true,
  api: {
    url: 'https://sfera.immobilieffegi.it'
  },
  paging:{
    size: 10
  }
};
